import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    licensing: [],
    periods: [],
    labels: [],
    order_column: 'id',
    order_type: 'desc',
    page: 1,
    page_size: 10,
    dialog: false,
    filter: {}
  },

  mutations: {
    setPeriods(state, payload) {
      state.periods = payload
    },
    setLabels(state, payload) {
      state.labels = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    }
  },

  actions: {
    readPeriods({ commit, state }) {
      commit('setLoading', true)

      axios.admin
        .get('cms/youtube/reports/periods')
        .then(r => {
          commit('setPeriods', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readLabels({ commit, state }) {
      commit('setLoading', true)

      axios.admin
          .get('cms/youtube/reports/labels')
          .then(r => {
            commit('setLabels', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    generateReport({ commit, state },exp) {
      commit('setLoading', true)
      console.log()
      axios.admin
          .get('cms/youtube/reports', {
            params: {
              ...exp
            }
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report'+exp.period+'_'+exp.label.replace(" ","_")+'_'+exp.type+'.csv')
            document.body.appendChild(link)
            link.click()
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    }
  }
}
